export default {
  empresas: [],
  empresa: {
    id: '',
    razonSocial: '',
    fantasia: '',
    iut: '',
    estado: '',
    esEmisor: false,
    esReceptor: false,
    esCanal: false,
    canal: '',
    esRcof: false,
    reglasNegocio: false,
    estadoEmpresa: false
  },
  advancedSign: false,
  simpleSign: false,
  userSigns: [],
  empresaSeleccionada: {
    id: '',
    razonSocial: '',
    fantasia: '',
    iut: '',
    estado: '',
    esEmisor: false,
    esReceptor: false,
    esCanal: false,
    canal: '',
    esRcof: false,
    reglasNegocio: false,
    estadoEmpresa: false
  },
  usersCompany: [],
  usersCompanyAssign: [],
  groupsCompany: [],
  isLoadingConfigurations: false,
  isSavingConfigurations: false,
  configurations: [],
  pagination: {
    items: 0,
    pages: 0
  },
  loading: false,
  usersGroup: [],
  successAction: false,
  substitutes: [],
  list: {},
  settingsLoading: false,
  settings: {},
  settingsCache: {}
};
